import { clsx } from 'clsx';
import ReactModal from 'react-modal';

import { CrossIcon } from '../svg/CrossIcon';

export const Modal = ({
  testPrefix = '',
  isClosable = true,
  isModalOpen,
  closeModal,
  children,
  header,
  disableContentPadding = false,
  className = 'min-w-[310px] max-w-[1120px] rounded-xs bg-white shadow-modal',
  overlayClassName = 'bg-overlay-decision-modal',
}: {
  closeModal?: () => void;
  isModalOpen: boolean;
  children: React.ReactElement;
  testPrefix: string;
  isClosable: boolean;
  /**
   * Optional full-bleed header rendered flush to the container edges (above the
   * padded body). When provided, the close icon is rendered inside it. Callers
   * that omit it keep the original close-icon-over-body behaviour.
   */
  header?: React.ReactNode;
  /**
   * Drops the default body padding so the body can own its own layout — needed
   * when the design has full-bleed regions (e.g. a coloured header + scroll
   * area). Defaults to false so existing callers are unaffected.
   */
  disableContentPadding?: boolean;
  /** Container classes (radius / background / shadow / sizing). */
  className?: string;
  /** Overlay/scrim classes. Defaults to the light decision-modal gradient. */
  overlayClassName?: string;
}) => {
  return (
    <ReactModal
      className={clsx(
        'absolute inset-[50%_auto_auto_50%] max-h-[96vh] -translate-x-1/2 -translate-y-1/2 outline-none',
        className,
      )}
      overlayClassName={clsx('fixed inset-0 z-[15]', overlayClassName)}
      isOpen={isModalOpen}
      shouldCloseOnOverlayClick={isClosable}
      onRequestClose={closeModal}
      ariaHideApp={false}
    >
      {header !== undefined ? (
        <div data-testid={`${testPrefix}Modal`} className="flex flex-col">
          <div className="relative">
            {header}
            {isClosable && (
              <CrossIcon
                className="absolute right-l top-xl h-xl w-xl cursor-pointer fill-denim-25 min-l:right-xl"
                onClick={closeModal}
                data-testid={`${testPrefix}Close`}
              />
            )}
          </div>
          <div
            className={clsx(
              !disableContentPadding && 'px-[14px] py-[25px] m900:px-[40px]',
            )}
          >
            {children}
          </div>
        </div>
      ) : (
        <div
          data-testid={`${testPrefix}Modal`}
          className={clsx(
            !disableContentPadding &&
              'px-[14px] py-[25px] m900:px-[40px] m900:py-[32px]',
          )}
        >
          {isClosable && (
            <CrossIcon
              className="absolute right-0 top-l h-xl w-xl cursor-pointer fill-denim-25"
              onClick={closeModal}
              data-testid={`${testPrefix}Close`}
            />
          )}
          {children}
        </div>
      )}
    </ReactModal>
  );
};
